const normalizePharmacyData = (lwData, translationsConfig, domainUrl) => {
  const { translations, urls } = translationsConfig || {};
  const { pharmacy_drug_id, pharmacy_drug_name } = lwData || {};
  let productLinkUrl;
  const urlPath = `${domainUrl ?? ""}${(urls == null ? void 0 : urls.pharmacyURL) || ""}` || "";
  try {
    productLinkUrl = new URL(urlPath);
  } catch (e) {
    productLinkUrl = {
      searchParams: new URLSearchParams(),
      toString: () => {
        const params = productLinkUrl.searchParams.toString();
        return params ? `${urlPath}?${params}` : urlPath;
      }
    };
  }
  productLinkUrl.searchParams.append(
    "drugIdentifierParam",
    pharmacy_drug_id || ""
  );
  productLinkUrl.searchParams.append(
    "drugNameParam",
    pharmacy_drug_name || ""
  );
  return {
    isChdiEligible: Boolean((lwData == null ? void 0 : lwData.item_chdi_eligible) ?? ""),
    isPublished: true,
    productInfoData: {
      partNumber: pharmacy_drug_id,
      productDescription: translations == null ? void 0 : translations.pharmacytext,
      productImageUrl: translations == null ? void 0 : translations.pharmacyimage,
      productLinkUrl: productLinkUrl.toString(),
      productName: pharmacy_drug_name
    }
  };
};
export {
  normalizePharmacyData
};
